import { PageHeader } from "@/pages/Categories";

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <PageHeader eyebrow="LEGAL" title="Privacy Policy" sub={`Last updated ${new Date().getFullYear()}.`} />
      <section className="max-w-3xl mx-auto px-6 lg:px-8 pb-24 text-[14.5px] text-zinc-300 leading-relaxed space-y-6">
        <Block t="Introduction">
          VYR Trade (&ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;) provides sourcing and trade-facilitation services for European and UK buyers of non-perishable goods from Indian manufacturers. This Privacy Policy explains how we collect, use and protect personal data when you interact with vyrtrade.com (the &ldquo;Site&rdquo;) and our services.
        </Block>
        <Block t="Data we collect">
          When you submit a sourcing brief, contact us, or otherwise interact with the Site, we may collect: your name, company name, email, phone / WhatsApp number, country, product enquiry details, files you upload, and basic technical data (IP, browser type, pages visited).
        </Block>
        <Block t="How we use your data">
          We use this data to: (a) respond to your sourcing enquiry, (b) coordinate supplier shortlisting and verification, (c) communicate with you about your request, (d) improve our services, and (e) meet legal and accounting obligations.
        </Block>
        <Block t="Sharing">
          We share enquiry details with relevant Indian suppliers only on a need-to-know basis to source the goods you have requested. We do not sell personal data. We may use service providers (email, hosting, file storage) under appropriate contractual safeguards.
        </Block>
        <Block t="Storage & security">
          Data is stored on secure infrastructure with access controls. We retain enquiry data for as long as needed to provide our services and for legitimate business and legal purposes.
        </Block>
        <Block t="Your rights">
          Depending on your jurisdiction (UK GDPR / EU GDPR), you may have rights to access, correct, delete, or restrict the processing of your personal data. To exercise these rights, email <a className="text-amber-400" href="mailto:reachus@vyrtrade.com">reachus@vyrtrade.com</a>.
        </Block>
        <Block t="Contact">
          For any privacy questions, please contact <a className="text-amber-400" href="mailto:reachus@vyrtrade.com">reachus@vyrtrade.com</a>.
        </Block>
      </section>
    </div>
  );
}

function Block({ t, children }) {
  return (
    <div>
      <div className="font-display text-xl font-semibold text-white">{t}</div>
      <p className="mt-2 text-zinc-300">{children}</p>
    </div>
  );
}
